import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ErrorPage } from './error';

@NgModule({
  declarations: [
    ErrorPage,
  ],
  imports: [
    IonicPageModule.forChild(ErrorPage),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ErrorPageModule {}



// WEBPACK FOOTER //
// ./src/pages/error/error.module.ts